import { taskIcons } from 'configs';
import React, { FC } from 'react';

interface IconProps {
  icon: string;
}

const Icon: FC<IconProps> = ({ icon }) => {
  const IconToRender = taskIcons[icon];

  return <IconToRender />;
};

export default Icon;
